// extracted by mini-css-extract-plugin
export default {"exportActKC2TemplateModal":"ExportActKC2TemplateModal_exportActKC2TemplateModal__qpJGc"};